import { FC } from 'react';
import TeaserComponent from '../components/teaser';

const Teaser: FC = () => {
  return <TeaserComponent />;
};

export default Teaser;
